module.exports = __webpack_public_path__ + "img/TECNOLOGIA-IGNIS-2021-2.324b4689.jpg";